import RoyalFlush from '../assets/images/turbo-poker/Royal-Flush.png';
import StraightFlush from '../assets/images/turbo-poker/Straight-Flush.png';
import Kare from '../assets/images/turbo-poker/Kare.png';
import FullHouse from '../assets/images/turbo-poker/Full-House.png';
import Flush from '../assets/images/turbo-poker/Flush.png';
import Straight from '../assets/images/turbo-poker/Straight.png';
import ThreeOfAKind from '../assets/images/turbo-poker/Thre-of-a-kind.png';
import TwoPair from '../assets/images/turbo-poker/Two-pair.png';
import Spades from '../assets/images/turbo-poker/Frame 3.png';
import MobRoyalFlush from '../assets/images/turbo-poker/mob-royal-flush.png';
import MobFlush from '../assets/images/turbo-poker/mob-flush.png';
import MobFourOfAKind from '../assets/images/turbo-poker/mob-four-of-a-kind.png';
import MobFullHouse from '../assets/images/turbo-poker/mob-full-house.png';
import MobSpades from '../assets/images/turbo-poker/Group 37529 (1).png';
import MobStreet from '../assets/images/turbo-poker/mob-street.png';
import MobStreetFlush from '../assets/images/turbo-poker/mob-street-flush.png';
import MobThreeOfAKind from '../assets/images/turbo-poker/mob-three-of-a-kind.png';
import MobTwoPair from '../assets/images/turbo-poker/mob-two-pair.png';

export const COMBINATIONS_PAYOUTS = [
  {
    winType: 9,
    img: RoyalFlush,
    imgMobile: MobRoyalFlush,
    type: 'ROYAL_FLUSH',
    rulesKey: 'GAME_RULES_P38',
    odd: 777,
  },
  {
    winType: 8,
    img: StraightFlush,
    imgMobile: MobStreetFlush,
    type: 'STRAIGHT_FLUSH',
    rulesKey: 'GAME_RULES_P39',
    odd: 50,
  },
  {
    winType: 7,
    img: Kare,
    imgMobile: MobFourOfAKind,
    type: 'FOUR_OF_A_KIND',
    rulesKey: 'GAME_RULES_P40',
    odd: 25,
  },
  {
    winType: 6,
    img: FullHouse,
    imgMobile: MobFullHouse,
    type: 'FULL_HOUSE',
    rulesKey: 'GAME_RULES_P41',
    odd: 8,
  },
  {
    winType: 5,
    img: Flush,
    imgMobile: MobFlush,
    type: 'FLUSH',
    rulesKey: 'GAME_RULES_P42',
    odd: 6,
  },
  {
    winType: 4,
    img: Straight,
    imgMobile: MobStreet,
    type: 'STRAIGHT',
    rulesKey: 'GAME_RULES_P43',
    odd: 4,
  },
  {
    winType: 3,
    img: ThreeOfAKind,
    imgMobile: MobThreeOfAKind,
    type: 'THREE_OF_A_KIND',
    rulesKey: 'GAME_RULES_P44',
    odd: 3,
  },
  {
    winType: 2,
    img: TwoPair,
    imgMobile: MobTwoPair,
    type: 'TWO_PAIR',
    rulesKey: 'GAME_RULES_P45',
    odd: 2,
  },
  {
    winType: 1,
    img: Spades,
    imgMobile: MobSpades,
    type: 'JACKS_OR_BETTER',
    rulesKey: 'GAME_RULES_P46',
    odd: 1,
  },
];

export const CARDS_TYPE = {
  0: 'card-pickes_A',
  1: 'card-pickes_2',
  2: 'card-pickes_3',
  3: 'card-pickes_4',
  4: 'card-pickes_5',
  5: 'card-pickes_6',
  6: 'card-pickes_7',
  7: 'card-pickes_8',
  8: 'card-pickes_9',
  9: 'card-pickes_10',
  10: 'card-pickes_J',
  11: 'card-pickes_Q',
  12: 'card-pickes_K',
  13: 'card-heart_A',
  14: 'card-heart_2',
  15: 'card-heart_3',
  16: 'card-heart_4',
  17: 'card-heart_5',
  18: 'card-heart_6',
  19: 'card-heart_7',
  20: 'card-heart_8',
  21: 'card-heart_9',
  22: 'card-heart_10',
  23: 'card-heart_J',
  24: 'card-heart_Q',
  25: 'card-heart_K',
  26: 'card-diamonds_A',
  27: 'card-diamonds_2',
  28: 'card-diamonds_3',
  29: 'card-diamonds_4',
  30: 'card-diamonds_5',
  31: 'card-diamonds_6',
  32: 'card-diamonds_7',
  33: 'card-diamonds_8',
  34: 'card-diamonds_9',
  35: 'card-diamonds_10',
  36: 'card-diamonds_J',
  37: 'card-diamonds_Q',
  38: 'card-diamonds_K',
  39: 'card-clover_A',
  40: 'card-clover_2',
  41: 'card-clover_3',
  42: 'card-clover_4',
  43: 'card-clover_5',
  44: 'card-clover_6',
  45: 'card-clover_7',
  46: 'card-clover_8',
  47: 'card-clover_9',
  48: 'card-clover_10',
  49: 'card-clover_J',
  50: 'card-clover_Q',
  51: 'card-clover_K',
  52: 'UNKNOWN',
};

export const UNKNOWN_CARD_TYPE = 52;

export const MAX_CARDS_COUNT_IN_TABLE = 5;

export const CARDS_BOX = new Array(MAX_CARDS_COUNT_IN_TABLE).fill(null);

export const CUTTING_CARD_VIEW_TYPES = 'backside-5';

export const CARDS_FRONT_TYPES = ['stack1', 'stack2', 'stack3', 'stack4'];

export const CARDS = {
  Spades_Ace: 0,
  Spades_2: 1,
  Spades_3: 2,
  Spades_4: 3,
  Spades_5: 4,
  Spades_6: 5,
  Spades_7: 6,
  Spades_8: 7,
  Spades_9: 8,
  Spades_10: 9,
  Spades_Jack: 10,
  Spades_Queen: 11,
  Spades_King: 12,
  Hearts_Ace: 13,
  Hearts_2: 14,
  Hearts_3: 15,
  Hearts_4: 16,
  Hearts_5: 17,
  Hearts_6: 18,
  Hearts_7: 19,
  Hearts_8: 20,
  Hearts_9: 21,
  Hearts_10: 22,
  Hearts_Jack: 23,
  Hearts_Queen: 24,
  Hearts_King: 25,
  Diamonds_Ace: 26,
  Diamonds_2: 27,
  Diamonds_3: 28,
  Diamonds_4: 29,
  Diamonds_5: 30,
  Diamonds_6: 31,
  Diamonds_7: 32,
  Diamonds_8: 33,
  Diamonds_9: 34,
  Diamonds_10: 35,
  Diamonds_Jack: 36,
  Diamonds_Queen: 37,
  Diamonds_King: 38,
  Clubs_Ace: 39,
  Clubs_2: 40,
  Clubs_3: 41,
  Clubs_4: 42,
  Clubs_5: 43,
  Clubs_6: 44,
  Clubs_7: 45,
  Clubs_8: 46,
  Clubs_9: 47,
  Clubs_10: 48,
  Clubs_Jack: 49,
  Clubs_Queen: 50,
  Clubs_King: 51,
  Unknown: 52,
};

const cardType = {
  DIAMOND: 'diamond',
  SPADES: 'spades',
  CLOVER: 'clover',
  HEART: 'heart',
};

const cardColor = {
  black: 'black',
  red: 'red',
};

export const CARDS_TYPES_DATA = {
  0: { icon: cardType.SPADES, name: 'A', color: cardColor.black },
  1: { icon: cardType.SPADES, name: '2', color: cardColor.black },
  2: { icon: cardType.SPADES, name: '3', color: cardColor.black },
  3: { icon: cardType.SPADES, name: '4', color: cardColor.black },
  4: { icon: cardType.SPADES, name: '5', color: cardColor.black },
  5: { icon: cardType.SPADES, name: '6', color: cardColor.black },
  6: { icon: cardType.SPADES, name: '7', color: cardColor.black },
  7: { icon: cardType.SPADES, name: '8', color: cardColor.black },
  8: { icon: cardType.SPADES, name: '9', color: cardColor.black },
  9: { icon: cardType.SPADES, name: '10', color: cardColor.black },
  10: { icon: cardType.SPADES, name: 'J', color: cardColor.black },
  11: { icon: cardType.SPADES, name: 'Q', color: cardColor.black },
  12: { icon: cardType.SPADES, name: 'K', color: cardColor.black },

  13: { icon: cardType.HEART, name: 'A', color: cardColor.red },
  14: { icon: cardType.HEART, name: '2', color: cardColor.red },
  15: { icon: cardType.HEART, name: '3', color: cardColor.red },
  16: { icon: cardType.HEART, name: '4', color: cardColor.red },
  17: { icon: cardType.HEART, name: '5', color: cardColor.red },
  18: { icon: cardType.HEART, name: '6', color: cardColor.red },
  19: { icon: cardType.HEART, name: '7', color: cardColor.red },
  20: { icon: cardType.HEART, name: '8', color: cardColor.red },
  21: { icon: cardType.HEART, name: '9', color: cardColor.red },
  22: { icon: cardType.HEART, name: '10', color: cardColor.red },
  23: { icon: cardType.HEART, name: 'J', color: cardColor.red },
  24: { icon: cardType.HEART, name: 'Q', color: cardColor.red },
  25: { icon: cardType.HEART, name: 'K', color: cardColor.red },

  26: { icon: cardType.DIAMOND, name: 'A', color: cardColor.red },
  27: { icon: cardType.DIAMOND, name: '2', color: cardColor.red },
  28: { icon: cardType.DIAMOND, name: '3', color: cardColor.red },
  29: { icon: cardType.DIAMOND, name: '4', color: cardColor.red },
  30: { icon: cardType.DIAMOND, name: '5', color: cardColor.red },
  31: { icon: cardType.DIAMOND, name: '6', color: cardColor.red },
  32: { icon: cardType.DIAMOND, name: '7', color: cardColor.red },
  33: { icon: cardType.DIAMOND, name: '8', color: cardColor.red },
  34: { icon: cardType.DIAMOND, name: '9', color: cardColor.red },
  35: { icon: cardType.DIAMOND, name: '10', color: cardColor.red },
  36: { icon: cardType.DIAMOND, name: 'J', color: cardColor.red },
  37: { icon: cardType.DIAMOND, name: 'Q', color: cardColor.red },
  38: { icon: cardType.DIAMOND, name: 'K', color: cardColor.red },

  39: { icon: cardType.CLOVER, name: 'A', color: cardColor.black },
  40: { icon: cardType.CLOVER, name: '2', color: cardColor.black },
  41: { icon: cardType.CLOVER, name: '3', color: cardColor.black },
  42: { icon: cardType.CLOVER, name: '4', color: cardColor.black },
  43: { icon: cardType.CLOVER, name: '5', color: cardColor.black },
  44: { icon: cardType.CLOVER, name: '6', color: cardColor.black },
  45: { icon: cardType.CLOVER, name: '7', color: cardColor.black },
  46: { icon: cardType.CLOVER, name: '8', color: cardColor.black },
  47: { icon: cardType.CLOVER, name: '9', color: cardColor.black },
  48: { icon: cardType.CLOVER, name: '10', color: cardColor.black },
  49: { icon: cardType.CLOVER, name: 'J', color: cardColor.black },
  50: { icon: cardType.CLOVER, name: 'Q', color: cardColor.black },
  51: { icon: cardType.CLOVER, name: 'K', color: cardColor.black },
};

export const shuffleAnimType = {
  CARDS_WRP: 'cards-wrp',
  CARD_DOWN: 'card-down',
  SHUFFLE_FIRST: 'shuffle-first',
  SHUFFLE_SECOND: 'shuffle-second',
  CLOSE_SHUFFLE_SECOND: 'close-shuffle-second',
};
